import * as React from 'react';
import { Button } from '@mui/material';
import { useFilterList } from '../../../context/FilterListProvider';
import { IData } from '../../../types';

/** Props for {@link ChartButton}. */
interface IChartButtonProps {
    /** Called with the current filter list when the button is clicked. */
    callback: (filterList: IData) => void;
}

export const ChartButton = ({ callback }: IChartButtonProps) => {
    const [filterList] = useFilterList();
    const onNewRule = () => callback(filterList);
    return (
        <Button size="small" onClick={onNewRule} >Chart View</Button>
    );
};

export default ChartButton;
